import "./App.css";
import { Routes, Route, BrowserRouter, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import LoginPage from "./pages/LoginPage";
import ForgetPasswordRequestPage from "./pages/ForgetPasswordRequestPage";
import PrivateRoute from "./utils/PrivateRoute";
import { AlertProvider } from "./context/AlertContext";
import { ToastProvider } from "./context/ToastContext";
import { ModalProvider } from "./context/ModalContext";
import { EsopProvider } from "./context/EsopContext";
import { WidgetProvider } from "./context/WidgetContext";
import DashboardLayout from "./layout/DashboardLayout";
import AuthLayout from "./layout/AuthLayout";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import TasksPage from "./pages/TasksPage";
import React from "react";
import FilesManagerPage from "./pages/FilesManagerPage";
import FolderFilesPage from "./pages/FolderFilesPage";
import EsopPage from "./pages/EsopPage";
import EmployeeManagementPage from "./pages/EmployeeManagementPage";
import AddEmployeePage from "./pages/AddEmployeePage";
import { FileManagerProvider } from "./context/FileMangerContext";
import { EmployeeManagementProvider } from "./context/EmployeeManagementContext";
import EditEmployeePage from "./pages/EditEmployeePage";
import PreviewEmployeePage from "./pages/PreviewEmployeePage";
const App = () => {
  return (
    <BrowserRouter>
      <ModalProvider>
        <ToastProvider>
          <FileManagerProvider>
            <AlertProvider>
              <AuthProvider>
                <EsopProvider>
                  <EmployeeManagementProvider>
                    <WidgetProvider>
                      <Routes>
                        <Route element={<DashboardLayout />}>
                          <Route
                            path="/dashboard/tasks"
                            element={
                              <PrivateRoute>
                                <TasksPage />
                              </PrivateRoute>
                            }
                          />
                          <Route
                            path="/dashboard/files-manager"
                            element={
                              <PrivateRoute>
                                <FilesManagerPage />
                              </PrivateRoute>
                            }
                          />
                          <Route
                            path="/dashboard/folder/:title/:folderId"
                            element={
                              <PrivateRoute>
                                <FolderFilesPage />
                              </PrivateRoute>
                            }
                          />
                          <Route
                            path="/dashboard/esop"
                            element={
                              <PrivateRoute>
                                <EsopPage />
                              </PrivateRoute>
                            }
                          />
                          <Route
                            path="/dashboard/employee-management"
                            element={
                              <PrivateRoute>
                                <EmployeeManagementPage />
                              </PrivateRoute>
                            }
                          />
                          <Route
                            path="/dashboard/employee-management/add-employee"
                            element={
                              <PrivateRoute>
                                <AddEmployeePage />
                              </PrivateRoute>
                            }
                          />
                          <Route
                            path="/dashboard/employee-management/edit-employee/:employeeId"
                            element={
                              <PrivateRoute>
                                <EditEmployeePage />
                              </PrivateRoute>
                            }
                          />
                          <Route
                            path="/dashboard/employee-management/preview/:employeeId"
                            element={
                              <PrivateRoute>
                                <PreviewEmployeePage />
                              </PrivateRoute>
                            }
                          />
                        </Route>
                        <Route element={<AuthLayout />}>
                          <Route element={<LoginPage />} path="/login" />
                          <Route
                            element={<ForgetPasswordRequestPage />}
                            path="/forgot-password-request"
                          />
                          <Route
                            element={<ResetPasswordPage />}
                            path="/reset-password/:token"
                          />
                          <Route
                            path="*"
                            element={<Navigate to="/dashboard/tasks" />}
                          />
                        </Route>
                      </Routes>
                    </WidgetProvider>
                  </EmployeeManagementProvider>
                </EsopProvider>
              </AuthProvider>
            </AlertProvider>
          </FileManagerProvider>
        </ToastProvider>
      </ModalProvider>
    </BrowserRouter>
  );
};

export default App;
